import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import AccountMenu from '../../Modules/AccountMenu'
import Api from './../../../Global/Modules/Api'

import WerkervaringReferentieToevoegen from '../../Modules/Werkervaring/WerkervaringReferentieToevoegen'
import WerkervaringReferentieOverzicht from '../../Modules/Werkervaring/WerkervaringReferentieOverzicht'

const FETCH_URL = "api/references/"
class WerkervaringReferenties extends Component {
	constructor() {
		super()
		this.handleClickEditRef = this.handleClickEditRef.bind(this)
		this.handleClickPostRef = this.handleClickPostRef.bind(this)
		this.state = {
			data: {}
		}
	}

	handleClickEditRef = id => {
		Api.GetApi(FETCH_URL + "member/" + id).then(data => {
			this.setState({ data: data })
		})

	}

	handleClickPostRef() {
		Api.print('Handle click post ref')
		this.child.getReferences()
	}

	render() {
		return (
			<div className="route">
				<AccountMenu />
				<div className="grey-bg">
					<h1 className="pageTitle">
						Referenties
            		</h1>
					<WerkervaringReferentieOverzicht ref={instance => { this.child = instance }} handle={this.handleClickEditRef} />
				</div>
				<div className="grey-bg">
					<WerkervaringReferentieToevoegen data={this.state.data} handle={this.handleClickPostRef} />
					<Link to="/werkervaring/beheren">Terug naar werkervaring</Link>
				</div>
			</div>
		);
	}
}

export default WerkervaringReferenties;



// WEBPACK FOOTER //
// ./src/components/Member/Pages/Werkervaring/WerkervaringReferenties.js